export enum ACTION_TRIGGERS {
  "TAP",
  "ANIMATION_ENDED",
  "PERMISSION_GRANTED",
  "ENABLE_POST_PERMISSION_CONTENT",
  "SOUND_LOADED",
  "JOYSTICK_START",
  "JOYSTICK_STOP",
  "EXPERIENCE_START",
  "MODEL_READY",
  "IMAGE_TARGET_FOUND",
  "IMAGE_TARGET_LOST",
  "FACE_FOUND",
  "FACE_LOST",
  //...
}
